import { createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid gx-lg-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Employee list", -1)
const _hoisted_3 = {
  class: "btn-toolbar",
  role: "toolbar",
  "aria-label": "Employee Actions"
}
const _hoisted_4 = {
  class: "btn-group me-2",
  role: "group",
  "aria-label": "List actions"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("button", {
  class: "btn btn-outline-primary",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#filters",
  "aria-expanded": "false",
  "aria-controls": "filters"
}, " Filters ", -1)
const _hoisted_6 = {
  class: "btn-group me-2",
  role: "group",
  "aria-label": "Mass actions"
}
const _hoisted_7 = {
  class: "collapse",
  id: "filters",
  role: "toolbar",
  "aria-label": "Employee filters"
}
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "requestFilter"
}, "Employee UID", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "accountFilter"
}, "Account ID", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "firstnameFilter"
}, "First Name", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "lastnameFilter"
}, "Last Name", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "emailFilter"
}, "Email", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "phoneFilter"
}, "Phone", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", {
  class: "input-group-text",
  id: "companyFilter"
}, "Company UID", -1)
const _hoisted_16 = {
  class: "btn-group me-2",
  role: "group",
  "aria-label": "Filter actions"
}
const _hoisted_17 = { class: "panel" }
const _hoisted_18 = { "aria-label": "Page navigation" }
const _hoisted_19 = { class: "row justify-content-center" }
const _hoisted_20 = { class: "col-sm-2" }
const _hoisted_21 = { class: "col-sm-4" }
const _hoisted_22 = {
  key: 0,
  class: "pagination justify-content-center"
}
const _hoisted_23 = {
  key: 1,
  class: "page-link"
}
const _hoisted_24 = { class: "col-sm-2" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_27 = { class: "table table-striped" }
const _hoisted_28 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "EmployeeUId"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "CompanyUId"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Account Id"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Name"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Email"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Phone"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Departments")
  ])
], -1)
const _hoisted_29 = { scope: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getList())),
          class: "btn btn-outline-primary"
        }, "Refresh"),
        _hoisted_5
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/sheqsy/employee/bulk'))),
          class: "btn btn-outline-info"
        }, "Bulk update"),
        _createVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/sheqsy/employee/:'))),
          class: "btn btn-outline-info"
        }, "Create employee")
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "xxx-x-x-xxx",
          "aria-label": "Employee",
          "aria-describedby": "requestFilter",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.requestFilter.EmployeeUId = $event)),
          onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.getList()), ["enter"]))
        }, null, 544), [
          [
            _vModelText,
            _ctx.requestFilter.EmployeeUId,
            void 0,
            { trim: true }
          ]
        ]),
        _hoisted_10,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "9999",
          "aria-label": "Account",
          "aria-describedby": "accountFilter",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.requestFilter.ReferenceId = $event)),
          onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.getList()), ["enter"]))
        }, null, 544), [
          [
            _vModelText,
            _ctx.requestFilter.ReferenceId,
            void 0,
            { trim: true }
          ]
        ]),
        _hoisted_11,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: ".*",
          "aria-label": "First Name",
          "aria-describedby": "firstnameFilter",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.requestFilter.FirstName = $event)),
          onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.getList()), ["enter"]))
        }, null, 544), [
          [
            _vModelText,
            _ctx.requestFilter.FirstName,
            void 0,
            { trim: true }
          ]
        ]),
        _hoisted_12,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: ".*",
          "aria-label": "Last Name",
          "aria-describedby": "lastnameFilter",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.requestFilter.LastName = $event)),
          onKeyup: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.getList()), ["enter"]))
        }, null, 544), [
          [
            _vModelText,
            _ctx.requestFilter.LastName,
            void 0,
            { trim: true }
          ]
        ]),
        _hoisted_13,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "abc@example.com",
          "aria-label": "Email",
          "aria-describedby": "emailFilter",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.requestFilter.Email = $event)),
          onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => (_ctx.getList()), ["enter"]))
        }, null, 544), [
          [
            _vModelText,
            _ctx.requestFilter.Email,
            void 0,
            { trim: true }
          ]
        ]),
        _hoisted_14,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "+61404 404 404",
          "aria-label": "Phone",
          "aria-describedby": "phoneFilter",
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.requestFilter.PhoneNumber = $event)),
          onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.getList()), ["enter"]))
        }, null, 544), [
          [
            _vModelText,
            _ctx.requestFilter.PhoneNumber,
            void 0,
            { trim: true }
          ]
        ]),
        _hoisted_15,
        _withDirectives(_createVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "xxx-x-x-xxx",
          "aria-label": "Company",
          "aria-describedby": "companyFilter",
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.requestFilter.CompanyUId = $event)),
          onKeyup: _cache[17] || (_cache[17] = _withKeys(($event: any) => (_ctx.getList()), ["enter"]))
        }, null, 544), [
          [
            _vModelText,
            _ctx.requestFilter.CompanyUId,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("button", {
          class: "btn btn-outline-primary",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.getList()))
        }, "Apply"),
        _createVNode("button", {
          class: "btn btn-outline-secondary",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.clearFiltersAndRefresh()))
        }, "Clear")
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("nav", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _withDirectives(_createVNode("select", {
              class: "form-select",
              "aria-label": "Results per page",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.requestPaging.Limit = $event)),
              onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.getList()))
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.requestPaging.Options, (item) => {
                return (_openBlock(), _createBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, ["value"]))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.requestPaging.Limit]
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            (_ctx.pageBounds)
              ? (_openBlock(), _createBlock("ul", _hoisted_22, [
                  _createVNode("li", {
                    class: ["page-item", _ctx.backendResponse.count > _ctx.requestPaging.Limit && _ctx.requestPaging.Skip > 0 ? '' : 'disabled']
                  }, [
                    _createVNode("a", {
                      class: "page-link",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.setPage('-1'))),
                      href: "#",
                      tabindex: "-1",
                      "aria-disabled": "true"
                    }, "Previous")
                  ], 2),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageBounds, (page) => {
                    return (_openBlock(), _createBlock("li", {
                      key: page.number,
                      class: ['page-item', page.current == true ? 'active' : '', page.number == 0 ? 'disabled' : '']
                    }, [
                      (page.number > 0)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "page-link",
                            href: "#",
                            onClick: ($event: any) => (_ctx.setPage(page.number))
                          }, _toDisplayString(page.number), 9, ["onClick"]))
                        : (_openBlock(), _createBlock("a", _hoisted_23, "…"))
                    ], 2))
                  }), 128)),
                  _createVNode("li", {
                    class: ["page-item", _ctx.backendResponse.count > (_ctx.requestPaging.Limit + _ctx.requestPaging.Skip) ? '' : 'disabled']
                  }, [
                    _createVNode("a", {
                      class: "page-link",
                      href: "#",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.setPage('+1')))
                    }, "Next")
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_24, [
            (_ctx.backendResponse.count > 0)
              ? (_openBlock(), _createBlock("p", _hoisted_25, _toDisplayString(_ctx.requestPaging.Skip > 0 ? _ctx.requestPaging.Skip : 1) + " to " + _toDisplayString(Math.min(_ctx.requestPaging.Skip + _ctx.requestPaging.Limit, _ctx.backendResponse.count)) + " of " + _toDisplayString(_ctx.backendResponse.count), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.backendResponse.count)
      ? (_openBlock(), _createBlock("div", _hoisted_26, [
          _createVNode("table", _hoisted_27, [
            _hoisted_28,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.backendResponse.items, (employee) => {
                return (_openBlock(), _createBlock("tr", {
                  key: employee.id,
                  class: employee.Suppressed ? 'bg-warning' : ''
                }, [
                  _createVNode("th", _hoisted_29, [
                    _createVNode(_component_router_link, {
                      to: '/sheqsy/employee/' + employee.EmployeeUId
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(employee.EmployeeUId), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createVNode("td", null, [
                    _createVNode(_component_router_link, {
                      to: '/sheqsy/company/' + employee.CompanyUId
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(employee.CompanyUId), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createVNode("td", null, _toDisplayString(employee.ReferenceId), 1),
                  _createVNode("td", null, _toDisplayString(employee.FirstName) + " " + _toDisplayString(employee.LastName), 1),
                  _createVNode("td", null, _toDisplayString(employee.Email), 1),
                  _createVNode("td", null, _toDisplayString(employee.PhoneNumber), 1),
                  _createVNode("td", null, [
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(employee.Departments, (dept, index) => {
                        return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(dept), 1))
                      }), 128))
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}